// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { BodyBuilder } from "../../../../common/interfaces/conversionworld/BodyBuilder";
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class BodybuilderLink extends Vue {
  @Prop()
  public bodybuilder!: BodyBuilder;

  @Prop({ default: "default" })
  public theme!: "default" | "search";

  @Prop({ default: "16-10" })
  public aspectRatio!: string;

  @Prop({ default: "black" })
  backgroundColor!: string;

  get link() {
    if (this.bodybuilder.is_approved) {
      return this.bodybuilder.link;
    }

    return "#";
  }
}
